import config from '@/config';
import store from '@/store';
import api from '@/utils/api';
import { get } from '@/utils/http';
import router from '@/router/index.js';
import { Message } from 'element-ui';
const pad2 = (str) => ('0' + str).substr(-2);

function fMoney(s, n) {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    let l = s.split('.')[0].split('').reverse();
    let r = s.split('.')[1];
    let t = '';
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
    }
    return t.split('').reverse().join('') + '.' + r;
}

function toDateTime(date, time) {
    if (!date) return '';
    date = date.toString();
    time = time ? time.toString() : '';
    let str = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`;
    if (date.length == 14) {
        str += ` ${date.substr(8, 2)}:${date.substr(10, 2)}:${date.substr(12, 2)}`;
    } else if (date.length == 6) {
        str = `${date.substr(0, 2)}:${date.substr(2, 2)}:${date.substr(4, 2)}`;
    } else if (time) {
        str += ` ${time.substr(0, 2)}:${time.substr(2, 2)}:${time.substr(4, 2)}`;
    }
    return str;
}

function fMoney2(m) {
    return parseFloat(m).toFixed(2);
}

function orderreleaseType(sts) {
    const status = {
        0: '手动发布',
        1: '定时发布'
    };
    return status[sts] || '未知状态';
}

function orderflag(sts) {
    const status = {
        0: true,
        1: false
    };
    return status[sts] || '未知状态';
}

function orderassesmentState(sts) {
    const status = {
        0: '待开始',
        1: '进行中',
        2: '已结束'
    };
    return status[sts] || '未知状态';
}

function orderfounder(sts) {
    const status = {
        0: '系统',
        1: '老师'
    };
    return status[sts] || '未知状态';
}
function projectPermissions(sts) {
    const status = {
        1: '考核',
        2: '竞赛',
        0: '练习'
    };
    return status[sts] || '未知状态';
}

function roleType(type) {
    const types = {
        2: '管理员',
        3: '老师',
        4: '学生'
    };
    return types[type] || '未知类型';
}

function educationDegreeList(id) {
    const list = [
        {
            name: '专科',
            value: 1
        },
        {
            name: '本科',
            value: 2
        },
        {
            name: '硕士',
            value: 3
        },
        {
            name: '博士',
            value: 4
        },
        {
            name: '其他',
            value: 5
        }
    ];
    let educationdegree = list.find((n, k) => {
        return n.value == id;
    }).name;
    return educationdegree;
}

function removeByValue(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
            arr.splice(i, 1);
            break;
        }
    }
}

//返回格式化时间，传参例如："yyyy-MM-dd hh:mm:ss"
function formatDate(fmt, date) {
    var date = date ? date : new Date();
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
}

function formateTime(num) {
    return num < 10 ? `0${num}` : num;
}

function getCaption(obj) {
    var index = obj.lastIndexOf('h');
    obj = obj.substring(index + 1, obj.length);
    return obj;
}

function toSubSystem(className = '', id = '', classId = '', pattern = '') {
    sessionStorage.setItem('token', store.state.token); //token
    sessionStorage.setItem('userName', store.state.userName); //用户名
    sessionStorage.setItem('class', className); //班级名
    sessionStorage.setItem('id', id); //考核或者竞赛id，且是否为练习模式，空为练习，不是空即为考核或者竞赛，后面会调用方法，基于考核或者竞赛id查询项目id，且做覆盖
    sessionStorage.setItem('tmsTeachId', id); //考核id
    sessionStorage.setItem('experimentId', '0'); //期货套利为0时为练习模式
    sessionStorage.setItem('isGuide', false); //默认取消用户引导
    sessionStorage.setItem('kdAssessmentId', id); //竞赛id
    sessionStorage.setItem('classId', classId); //班级id
    sessionStorage.setItem('userId', store.state.userId); //用户id
    sessionStorage.setItem('pattern', pattern); //实验模式，0：单期权，1多期权，2期货套保，3期货套利，4期权交易
    // 空为练习，不是空即为考核或者竞赛，
    if (sessionStorage.getItem('id') != '') {
        //如果班级id不为空，即为考核模式，否则为竞赛模式
        let source = '';
        if (sessionStorage.getItem('classId') != '') {
            sessionStorage.setItem('tmsTeachId', '');
            source = 1;
        } else {
            sessionStorage.setItem('kdAssessmentId', '');
            source = 0;
        }
        let params = {
            id: sessionStorage.getItem('id'),
            source: source
        };
        get(api.queryProjectIdAndPattenById, params).then((res) => {
            let projectId = res.Info.projectId;
            let pattern = res.Info.pattern;
            sessionStorage.setItem('id', projectId);
            switch (pattern) {
                case 0:
                    location.href = config.subSystem1;
                    break;
                case 1:
                    location.href = config.subSystem2;
                    break;
                case 2:
                    location.href = config.subSystem3;
                    break;
                case 3:
                    sessionStorage.setItem('experimentId', id);
                    location.href = config.subSystem4;
                    break;
                case 4:
                    sessionStorage.setItem('experimentId', id);
                    location.href = config.subSystem5;
                    break;
            }
        });
    } else {
        switch (pattern) {
            case 0:
                location.href = config.subSystem1;
                sessionStorage.setItem('id', 1);
                break;
            case 1:
                location.href = config.subSystem2;
                sessionStorage.setItem('id', 2);
                break;
            case 2:
                location.href = config.subSystem3;
                sessionStorage.setItem('id', 67);
                break;
            case 3:
                location.href = config.subSystem4;
                sessionStorage.setItem('id', 66);
                break;
            case 4:
                location.href = config.subSystem5;
                sessionStorage.setItem('id', 68);
                break;
        }
    }
}

function encodeString(str) {
    if (str.includes('[') || str.includes(']')) {
        let newStr = '';
        for (let i of str) {
            if (i == '[' || i == ']') {
                newStr += encodeURI(i);
            } else {
                newStr += i;
            }
        }
        return newStr;
    }
    return str;
}

function logout() {
    store.replaceState({});
    sessionStorage.removeItem('kd_client_username');
    location.reload();
}

//返回上一页
function goBack() {
    router.go(-1);
}

function autoLogout() {
    let lastTime = new Date().getTime();
    document.onmousedown = () => {
        lastTime = new Date().getTime();
    };

    setInterval(() => {
        if (sessionStorage.getItem('kd_client_username') && new Date().getTime() - lastTime > config.autoLogoutTime) {
            Message.error('用户登录过期，请重新登录');
            setTimeout(logout, 1500);
        }
    }, 1000);
}
autoLogout();

export default {
    orderfounder,
    projectPermissions,
    orderassesmentState,
    goBack,
    fMoney,
    fMoney2,
    toDateTime,
    orderreleaseType,
    orderflag,
    roleType,
    educationDegreeList,
    removeByValue,
    formateTime,
    getCaption,
    toSubSystem,
    formatDate,
    encodeString,
    logout
};
